export const scrollProps = {
  smooth: true,
  activeClass: 'active',
  spy: true,
  duration: 300,
  offset: -10,
}
